import angular from 'angular';

export default angular
	.module('ui.cian.click-outside', [])
	.directive('cianUiClickOutside', ['$document', '$parse', '$timeout', ($document, $parse, $timeout) => ({
		link($scope, el, attr) {
			$timeout(() => {
				const clickOutside = $parse(attr.cianUiClickOutside);

				const eventHandler = () => {
					$scope.$apply(function () {
						clickOutside($scope);
					});
				};

				const eventStopPropagation = (event) => {
					if (!angular.element(event.target).attr('continue-propagation')) {
						event.stopPropagation();
					}
				};

				$document.bind('click', eventHandler);

				angular.element(el).bind('click', eventStopPropagation);

				$scope.$on('$destroy', () => {
					$document.unbind('click', eventHandler);
					angular.element(el).unbind('click', eventStopPropagation);
				});

			}, 0, false);
		}
	})])
	.name;
